import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: { main: "#ffd200" },
    secondary: { main: "#f2f2f2" },
    info: { main: "#000" },
    common: { black: "#000000", white: "#FFFFFF" },
    grey: {},
  },
  typography: {
    fontFamily: '"Noto Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    allVariants: {
      fontFamily: '"Noto Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    },
  },
});
